import { gql } from "@apollo/client";

export const GET_SOS_STATUSES = (
    sos_id?: number,
    page?: number,
    pageSize?: number,
    orderBy: "asc" | "desc" = "desc",
    startDate?: string,
    endDate?: string
) => {
    // Paginación
    // Si no se pasa pageSize o page, no se aplica paginación
    const paginationArgs = pageSize && page
        ? `, limit: ${pageSize}, offset: ${(page ? (page - 1): 0) * pageSize}`
        : "";

    // Filtros para condición where
    const filters: string[] = [];

    // Rango de fechas
    if (startDate || endDate) {
        const dateConditions = [];
        if (startDate) dateConditions.push(`_gte: "${startDate}"`);
        if (endDate) dateConditions.push(`_lte: "${endDate}"`);
        // Si hay un solo elemento en dateConditions, se agrega el operador de comparación
        filters.push(`created_at: { ${dateConditions.join(", ")} }`);
    }

    // filtrar por poste sos
    if (sos_id) {
        filters.push(`sos_id: {_eq: ${sos_id}}`);
    }
    // Si hay filtros, se agrega la cláusula where
    const whereClause = filters.length > 0 ? `, where: { ${filters.join(", ")} }` : "";

    return gql`
        query MyQuery {
            its_sos_statuses_aggregate(
                order_by: {created_at: ${orderBy}}
                ${whereClause}
            ) {
                aggregate {
                    count
                }
            }
            its_sos_statuses(
                order_by: {created_at: ${orderBy}}
                ${whereClause}
                ${paginationArgs}
            ) {
                id
                data
                sos_id
                so {
                    description
                }
                received_at
                created_at
                updated_at
            }
        }
    `;
}

export const GET_SOS_ONLINE_STATUSES = () => {

    return gql`
        query MyQuery {
            its_sos_online_status_aggregate {
                aggregate {
                count
                }
            }
            its_sos_online_status {
                description
                is_online
                last_event_at
                sos_id
            }
        }
    `;
}